import React from 'react';
import styled from 'styled-components';

interface TagFilterProps {
  tags: string[];
  activeTag: string | null;
  onTagClick: (tag: string) => void;
  onShowAllClick: () => void;
}

const Container = styled.div`
  position: fixed;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 5px 10px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  max-width: 80%;
  justify-content: center;
  z-index: 9999;
`;

const TagItem = styled.div<{ $isActive: boolean }>`
  padding: 3px 8px;
  background-color: ${props => props.$isActive ? '#2196f3' : '#e0e0e0'};
  color: ${props => props.$isActive ? 'white' : 'black'};
  border-radius: 15px;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: all 0.2s ease;
  z-index: 9999;
  &:hover {
    background-color: ${props => props.$isActive ? '#1976d2' : '#bdbdbd'};
  }
`;

const ShowAllButton = styled.div<{ $isVisible: boolean }>`
  padding: 3px 8px;
  background-color: #4caf50;
  color: white;
  border-radius: 15px;
  font-size: 12px;
  cursor: pointer;
  display: ${props => props.$isVisible ? 'flex' : 'none'};
  align-items: center;
  transition: all 0.2s ease;
  z-index: 9999;
  &:hover {
    background-color: #388e3c;
  }
`;

const TagFilter: React.FC<TagFilterProps> = ({ 
  tags, 
  activeTag, 
  onTagClick, 
  onShowAllClick 
}) => {
  if (tags.length === 0) {
    return null;
  }

  return (
    <Container>
      <ShowAllButton 
        $isVisible={!!activeTag} 
        onClick={onShowAllClick}
      >
        すべて表示
      </ShowAllButton>
      {tags.map(tag => (
        <TagItem 
          key={tag} 
          $isActive={activeTag === tag} 
          onClick={() => onTagClick(tag)}
        >
          {tag}
        </TagItem>
      ))}
    </Container>
  );
};

export default TagFilter; 